import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck } from "lucide-react";
import CallbackDialog from "@/components/CallbackDialog";

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-navy py-20 text-white sm:py-24" data-testid="final-cta-section">
      <div className="pointer-events-none absolute -left-32 top-0 h-80 w-80 rounded-full bg-gold/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-gold/5 blur-3xl" />

      <div className="relative mx-auto max-w-5xl px-5 text-center sm:px-8">
        <div className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-white/5 px-4 py-1.5 text-[11px] uppercase tracking-[0.2em] text-gold backdrop-blur">
          <ShieldCheck size={12} /> One last step
        </div>
        <h2 className="mt-6 font-serif text-3xl leading-tight sm:text-5xl">
          Your family deserves clarity. <br className="hidden sm:block" />
          <span className="text-gold">Your legacy deserves protection.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-sm text-white/75 sm:text-base">
          Don't wait for a "right time". Create your professionally structured will today — it takes
          10 minutes and is the most loving gift you can leave your family.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <Link to="/will-generator">
            <Button
              size="lg"
              className="bg-gold px-8 text-navy hover:bg-[#E5C87A]"
              data-testid="final-cta-start"
            >
              Create My Will – ₹99 <ArrowRight size={18} className="ml-2" />
            </Button>
          </Link>
          <CallbackDialog
            size="lg"
            variant="outline"
            className="border-white/30 bg-white/5 px-8 text-white hover:border-gold hover:bg-white/10 hover:text-gold"
            label="Speak To Our Team"
            testId="final-cta-callback-dialog"
            buttonTestId="final-cta-callback"
          />
        </div>
        <p className="mt-3 text-xs text-white/55" data-testid="final-cta-callback-hint">
          Prefer speaking first? Request a callback and our team will contact you.
        </p>
        <p
          className="mt-8 font-serif text-base italic text-gold/85 sm:text-lg"
          data-testid="final-cta-emotional-line"
        >
          "The most expensive Will is the one never written."
        </p>
      </div>
    </section>
  );
}
